import React from 'react';

import Settings from '../settings';

const { $ } = window;

export default class OpenUrlDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = props;
  }

  componentWillReceiveProps(props) {
    this.setState(props);
  }

  componentDidMount() {
    $('#open-url-dialog.ui.modal').modal({
      onHidden: () => this.hide(),
      onApprove: () => this.open()
    });
  }

  componentDidUpdate() {
    $('#open-url-dialog.ui.modal').modal(this.props.visible ? 'show' : 'hide');
  }

  hide() {
    this.state.toolbar.setState({
      showOpenUrlDialog: false
    });
  }

  open() {
    let urls = this.state.urls.split("\n").map(x => x.trim()).filter(x => x != '');

    let project = this.state.toolbar.state.project;
    let pages = [];
    urls.forEach(url => {
      let proxyUrl = `/ba-simple-proxy.php?mode=native&url=${encodeURIComponent(url)}`;
      let page = project.loadPage(proxyUrl, url);
      pages.push(page);
    });
    if (pages.length > 0) {
      project.selectPage(pages[0]);
    }

    this.hide();
  }

  update(e) {
    let data = {};
    data[e.target.name] = e.target.value;
    this.setState(data);
  }

  render() {
    return (
      <div className="ui modal" id="open-url-dialog">
        <div className="header">
          Загрузка изображений
        </div>
        <div className="content">
          <div className="ui form">
            <div className="field">
              <label>Ссылки на изображения:</label>
              <textarea name="urls" value={this.state.urls} onChange={this.update.bind(this)} />
            </div>
          </div>
        </div>
        <div className="actions">
          <button className="ui right primary approve button">Ок</button>
          <button className="ui right cancel button">Отмена</button>
        </div>
      </div>
    );
  }
}
